import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrailerOperationTypesGridComponent } from './trailer-operation-types-grid.component';
import {DxDataGridModule} from 'devextreme-angular';
import {TabModule} from '../tab/tab.module';
import {GridDefaultModule, GridTitleModule} from 'shared';



@NgModule({
  declarations: [TrailerOperationTypesGridComponent],
    imports: [
        CommonModule,
        DxDataGridModule,
        TabModule,
        GridTitleModule,
        GridDefaultModule
    ],
  exports: [TrailerOperationTypesGridComponent]
})
export class TrailerOperationTypesGridModule { }
